<template>
  <div>
    <b-dropdown
      class="bg-white"
      variant="outline-dark"
      size="sm"
      :no-caret="exporting"
    >
      <template #button-content>
        <GjIcon
          class="mr-50"
          name="Redirect"
        />
        {{ exporting ? $tk('ClientPortal.Property.Earnings.ExportData') : $tk('ClientPortal.Property.Earnings.ExportingData') }}
        <b-spinner
          v-if="exporting"
          small
          class="ml-2"
          label="Exporting data"
        />
      </template>
      <b-dropdown-item @click="exportData(1)">
        {{ $tk('ClientPortal.Property.Earnings.ExportDataAsCSV') }}
      </b-dropdown-item>
      <b-dropdown-item @click="exportData(2)">
        {{ $tk('ClientPortal.Property.Earnings.ExportDataAsExcel') }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import notification from '@/mixins/toastification'
import PropertiesService from '@/api/client/properties.service'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dateRange: String,
    // eslint-disable-next-line vue/require-default-prop
    propertyIds: Array,
    // eslint-disable-next-line vue/require-default-prop
    monetizationContentIds: Array,
  },
  data() {
    return {
      exporting: false,
    }
  },
  methods: {
    exportData(exportType) {
      if (exportType === 1) {
        this.exportCsvData()
      } else {
        this.exportExcelData()
      }
    },
    async exportCsvData() {
      this.exporting = true

      try {
        const response = await PropertiesService.exportCsv(this.dateRange, this.propertyIds, this.monetizationContentIds, this.$route.params.accountId)
        this.createDownloadLink(response, 'csv', this.dateRange)
      } catch (err) {
        this.error(err.message)
      } finally {
        this.exporting = false
      }
    },
    async exportExcelData() {
      this.exporting = true

      try {
        const response = await PropertiesService.exportExcel(this.dateRange, this.propertyIds, this.monetizationContentIds, this.$route.params.accountId)
        this.createDownloadLink(response, 'xlsx', this.dateRange)
      } catch (err) {
        this.error(err.message)
      } finally {
        this.exporting = false
      }
    },
    createDownloadLink(file, extension, dateRange) {
      const name = `Property Report - ${dateRange}.${extension}`

      const url = window.URL.createObjectURL(new Blob([file]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    },
  },
}
</script>
